export const SEEMPTYPE = Object.freeze({
  New: 0,
  ClientAmendment: 1
});

export const AMENDMENTTYPE = Object.freeze({
  Major: 0,
  Minor: 1
});